import { call, fork, put, select, takeLatest } from 'redux-saga/effects'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../../home/selectors'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { IPcr } from '../../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../../user/selectors'
import { getAirwaySelector } from '../selectors'
import { saveAirway, setReasonsForFailure } from '../store/airway.actions'
import { AirwayConstants } from '../store/airway.constants'
import { IAirwayState } from '../store/airway.types'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { setInputRows } from '../../../../components/procedure/store/procedure.actions'
import { IProcedureState } from '../../../../components/procedure/store/procedure.types'
import { IMultiSelectProps } from '../../../../components/multiSelect/MultiSelect.component'
import { getDatapointsConfigSelector } from '../../../configurations/selectors'
import { IDataPointsConfig } from '../../../configurations/store/configurations.types'

export function* setSuccessfulAttempt() {
  const airwayState: IAirwayState = yield select(getAirwaySelector)
  const { successfulAttempt } = airwayState
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    try {
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      if (pcrDoc.patient?.airwayStateList && pcrDoc.patient?.airwayStateList.length) {
        const index = pcrDoc.patient?.airwayStateList?.findIndex((airway) => airway.key === airwayState.key)
        if (index !== -1) {
          if (pcrDoc.patient.airwayStateList[index].successfulAttempt !== successfulAttempt) {
            yield put(saveAirway())
            yield fork(updateReasonsForFailure, successfulAttempt)
          }
        }
      } else {
        yield put(saveAirway())
        yield fork(updateReasonsForFailure, successfulAttempt)
      }
    } catch (e) {
      yield put(throwPcrException(`setSuccessfulAttempt() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}

function* updateReasonsForFailure(successfulAttempt: boolean) {
  const procedureState: IProcedureState = yield select(getProcedureStateSelector)
  const { inputRows } = procedureState
  const { DP_AIRWAY_FAILURE }: IDataPointsConfig = yield select(getDatapointsConfigSelector)

  inputRows.forEach((row) =>
    row.inputs.forEach((input) => {
      if (input.key === AirwayConstants.SET_REASONS_FOR_FAILURE) {
        input.hidden = !DP_AIRWAY_FAILURE || successfulAttempt
        if (input.hidden) {
          const reasonForFailureProps = input.props as IMultiSelectProps
          reasonForFailureProps.savedValues = []
        }
      }
    })
  )
  yield put(setInputRows(inputRows))

  if (successfulAttempt) yield put(setReasonsForFailure([]))
}

export function* setSuccessfulAttemptSaga() {
  yield takeLatest([AirwayConstants.SET_SUCCESSFUL_ATTEMPT], performWithMutexHOG, setSuccessfulAttempt)
}
